import FirebaseService from '@/services/FirebaseService'
import { useQuery } from '@tanstack/vue-query'
import { httpsCallable } from 'firebase/functions'

export default function useGetUserAvatar(userId: string) {
  return useQuery({
    queryKey: ['user-avatar', userId],
    queryFn: () => fetchUserAvatar(userId),
    enabled: !!userId, // Évite d'exécuter la requête si userId est null/undefined
  })
}

const fetchUserAvatar = async (userId: string) => {
  try {
    const functions = await FirebaseService.functions()
    const getAvatar = httpsCallable(functions, 'user-getUserAvatarV2')
    const response = await getAvatar({ id: userId }) as any
    return response.data.avatar
  } catch (error) {
    console.error('Erreur lors de la récupération de l’avatar :', error)
    throw error // Permet à TanStack Query de gérer l'erreur
  }
}
